/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  };

  growApp.prototype.numberingParking = function () {

    // Grab image containers
    let images = document.querySelectorAll(".c-block-slide__contents");

    // Error Handling
    // When Images are not in the page
    if (!images) return;
    if (images.length === 0) return;


    // Looping through containers
    images.forEach(image => {

      // images
      const pieces = image.children;

      if (pieces.length > 0) {

        // Turn images into Array for looping
        const piecesArray = Array.from(pieces);

        piecesArray.forEach((piece, index) => {
          const div = document.createElement("div");
          const num = document.createTextNode(String(index + 1));
          div.appendChild(num);
          div.classList.add("c-block-slide__numbering");
          piece.insertAdjacentElement("afterbegin", div);
        })
      }
    })
  };

  growApp.prototype.enterAnimation = function () {
    if (!$('.c-main-visual').length) {
      return false;
    }

    var win = $(window).innerWidth();
    if (win < 950) {
      $('body').addClass('is-already');
      return false;
    }


    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }
    let $body = $('body')
    let $header = $('.l-header');
    let $mainNews =$('.c-news-sm');

    var loaderFunction = function () {
      // ここから実行
      if ($body) {
        changeClass($mainNews, "is-active", 1000).then(function () {
          changeClass($header, "is-active", 1000).then(function () {
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      $body.addClass('is-already');
    }
  };

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.numberingParking();
  });
})(jQuery);
